"use client";

import Link from "next/link";
import { signOut, useSession } from "next-auth/react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

export function NavBar() {
  const { data: session } = useSession();

  return (
    <header className="sticky top-0 z-50 border-b bg-white dark:bg-zinc-950">
      <div className="flex h-14 items-center px-6 gap-6">
        <Link href="/" className="font-semibold text-lg">
          MRO 数据查询
        </Link>
        <Separator orientation="vertical" className="h-6" />
        {session && (
          <nav className="flex items-center gap-4">
            <Link
              href="/fa-details"
              className="text-sm text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-50"
            >
              FA 固定资产明细
            </Link>
            <Link
              href="/crm-contacts"
              className="text-sm text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-50"
            >
              CRM 客户联系人变更
            </Link>
          </nav>
        )}
        <div className="flex-1" />
        {session && (
          <div className="flex items-center gap-4">
            <span className="text-sm text-zinc-500">{session.user?.name}</span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => signOut({ callbackUrl: "/login" })}
            >
              登出
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}